import { createUserWithEmailAndPassword } from "firebase/auth";
import React, { useState, useEffect } from "react";
import { auth } from "../firebase";
import { Link, useNavigate } from "react-router-dom";
import LearningLayout from "../Components/LearningPlatform/LearningLayout";
import { FaEnvelope, FaLock, FaUserPlus, FaInfoCircle } from "react-icons/fa";

const RegisterPage = () => {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState(false);
    const navigate = useNavigate();

    useEffect(() => {
        if (successMessage) {
            navigate('/progress');
        }
    }, [successMessage, navigate]);

    const signUp = (e) => {
        e.preventDefault();
        createUserWithEmailAndPassword(auth, email, password)
            .then((userCredential) => {
                setSuccessMessage(true);
                setErrorMessage('');
            })
            .catch((error) => {
                console.log(error);
                setErrorMessage(error.message);
                setSuccessMessage(false);
            });
    };

    return (
        <LearningLayout>
            <div className='flex-1 overflow-auto flex flex-col'>
                <div className='flex-1 flex items-center justify-center p-4 sm:p-6 lg:p-8'>
                    <div className='w-full max-w-md'>
                        {/* Form Card */}
                        <div className='bg-white/95 backdrop-blur-md rounded-2xl shadow-xl border border-white/50 overflow-hidden'>
                            {/* Header */}
                            <div className='bg-gradient-to-r from-violet-600 to-indigo-600 p-8 text-center'>
                                <div className='flex justify-center mb-4'>
                                    <div className='bg-white/20 backdrop-blur-sm p-4 rounded-full'>
                                        <FaUserPlus className='text-4xl text-white' />
                                    </div>
                                </div>
                                <h1 className='text-3xl font-bold text-white mb-2'>Crie uma conta</h1>
                                <p className='text-white/90 text-sm'>Assim você poderá acompanhar seu progresso!</p>
                            </div>

                            {/* Form */}
                            <form onSubmit={signUp} className='p-8'>
                                {errorMessage && (
                                    <div className='mb-6 p-4 bg-red-50 border border-red-200 rounded-lg'>
                                        <p className='text-red-600 text-sm'>Email ou senha inválida. Tente novamente!</p>
                                    </div>
                                )}

                                {/* Email Input */}
                                <div className='mb-5'>
                                    <label className='block text-sm font-medium text-gray-700 mb-2'>
                                        Email
                                    </label>
                                    <div className='relative'>
                                        <div className='absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none'>
                                            <FaEnvelope className='text-gray-400' />
                                        </div>
                                        <input
                                            type="email"
                                            placeholder="seu@email.com"
                                            value={email}
                                            onChange={(e) => setEmail(e.target.value)}
                                            required
                                            className='w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-transparent transition-all duration-200 placeholder-gray-400'
                                        />
                                    </div>
                                </div>

                                {/* Password Input */}
                                <div className='mb-6'>
                                    <label className='block text-sm font-medium text-gray-700 mb-2'>
                                        Senha
                                    </label>
                                    <div className='relative'>
                                        <div className='absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none'>
                                            <FaLock className='text-gray-400' />
                                        </div>
                                        <input
                                            type="password"
                                            placeholder="••••••••"
                                            value={password}
                                            onChange={(e) => setPassword(e.target.value)}
                                            required
                                            className='w-full pl-10 pr-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-violet-500 focus:border-transparent transition-all duration-200 placeholder-gray-400'
                                        />
                                    </div>
                                </div>

                                {/* Newsletter Notice */}
                                <div className='mb-6 p-4 bg-blue-50 border border-blue-200 rounded-lg'>
                                    <div className='flex items-start gap-3'>
                                        <FaInfoCircle className='text-blue-600 mt-0.5 flex-shrink-0' />
                                        <div className='text-xs text-blue-800'>
                                            <p className='mb-1'>Ao criar uma conta, você será inscrito automaticamente em nossa newsletter.</p>
                                            <p>No entanto, não se preocupe! Você pode cancelar sua inscrição quando desejar.</p>
                                        </div>
                                    </div>
                                </div>

                                {/* Submit Button */}
                                <button
                                    type="submit"
                                    className='w-full bg-gradient-to-r from-violet-600 to-indigo-600 text-white font-semibold py-3 px-6 rounded-lg hover:from-violet-700 hover:to-indigo-700 transition-all duration-200 shadow-lg hover:shadow-xl transform hover:scale-[1.02]'
                                >
                                    Criar Conta
                                </button>

                                {/* Login Link */}
                                <div className='mt-6 text-center'>
                                    <p className='text-gray-600 text-sm'>
                                        Já tem uma conta?{' '}
                                        <Link
                                            to="/login"
                                            className='text-violet-600 hover:text-violet-700 font-medium hover:underline transition-colors'
                                        >
                                            Entrar
                                        </Link>
                                    </p>
                                </div>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </LearningLayout>
    );
};

export default RegisterPage




{/* <div className="sign-in-container">
                <form className="register-form" onSubmit={signUp}>
                    <h1>Crie uma conta</h1>
                    <p className="contact-description">Assim você poderá ver seu progresso em cada quiz e nível.</p>
                    {errorMessage && (<p className="error-message">Email ou senha inválida. Tente novamente!</p>)}
                    <input
                        type="email"
                        placeholder="Enter your email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                    ></input>
                    <input
                        type="password"
                        placeholder="Enter your password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                    ></input>
                    <button type="submit">Sign Up</button>
                </form> */}